import React from "react";
import { Box, Typography, Button } from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import { useHistory } from "react-router-dom";
import { useQuery } from "@apollo/client";
import "react-awesome-slider/dist/styles.css";
import BackIcon from "@mui/icons-material/ArrowBack";
import missIcon from "../../assets/images/miss.png";
import { GET_LECTION_QUERY } from "../../queries/queries";
import Loading from "../loading";

const styles = (theme) => ({
  root: {
    color: "#fff",
    backgroundColor: "#4397E6",
    height: "100vh",
    backgroundImage: "linear-gradient(to top,#7CD1EA 0%, #4397E6 100%)",
  },
  header: {
    fontSize: 27,
    fontWeight: 200,
  },
  presentIcon: {},
  points: {
    fontSize: 34,
    fontWeight: 600,
  },
  description: {
    fontSize: 15,
    padding: "10px 0px",
    fontWeight: 100,
  },
  descriptionBox: {
    width: 250,
  },
  button: {
    margin: theme.spacing ? theme.spacing(2) : "16px",
    backgroundColor: "#fff",
    borderRadius: 30,
    width: 300,
    height: 56,
    color: "#238CB9",
    fontWeight: "bold",
  },
  buttonBox: {
    position: "relative",
  },
  backIcon: {
    marginRight: 10,
  },
  buttonText: {
    margin: 0,
    fontSize: 16,
    fontWeight: "bold",
  },
});

const Failed = ({
  classes,
  match: {
    params: { lectionId },
  },
}) => {
  let history = useHistory();
  const { loading, error, data } = useQuery(GET_LECTION_QUERY, {
    variables: { id: lectionId },
    fetchPolicy: "no-cache",
  });

  if (loading) return <Loading />;
  if (error) {

    return <h1> {error}</h1>
  }

  const lection = data.section;

  return (
    <Box
      className={classes.root}
      display="flex"
      flexDirection="column"
      justifyContent="center"
      data-testid="failed"
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="space-around"
        height="80%"
      >
        <Typography
          align="center"
          className={classes.header}
          variant="body1"
          component="p"
        >
          Upppsss. <br />
          Das war nichts.
        </Typography>
        <img
          alt="No courses left"
          src={missIcon}
          className={classes.presentIcon}
        />
        <Box className={classes.descriptionBox}>
          <Typography
            className={classes.description}
            align="center"
            variant="body1"
            color="inherit"
            component="p"
          >
            Du hast die Lektion leider nicht erfolgreich beendet
          </Typography>
        </Box>
        <Box display="flex" justifyContent="center" alignItems="center">
          <Button
            className={classes.button}
            variant="contained"
            color="inherit"
            size="large"
            onClick={(e) => {
              e.preventDefault();
              history.push(`/lections/playlection/${lection.id}`);
            }}
          >
            <Box display="flex" alignItems="center">
              <BackIcon className={classes.backIcon} />
              <Typography
                gutterBottom
                align="left"
                variant="button"
                component="p"
                className={classes.buttonText}
                color="inherit"
              >
                Neuer Versuch
              </Typography>
            </Box>
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default withStyles(styles)(Failed);
